// extracted by mini-css-extract-plugin
module.exports = {"contact__main":"style_contact__main__fIX9f","contact__content":"style_contact__content__48PVs","contact__text":"style_contact__text__1AGw9"};